<template>
  <div
    :style="{
      height: `${containerHeight}px`,
      maxHeight: `${containerHeight}px`,
      overflow: 'hidden',
    }"
  >
    <div ref="el">
      <slot></slot>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import anime from "animejs";
import { useElementSize } from "@vueuse/core";

const el = ref<HTMLDivElement | null>(null);

const { width, height } = useElementSize(el);
const containerHeight = ref(height.value);

onMounted(() => {
  containerHeight.value = height.value;
});


watch(height, () => {
  anime({
    targets: containerHeight,
    value: height.value,
    easing: "easeInOutCubic",
    duration: 300,
  });
});
</script>
<style lang="scss" scoped></style>
